export default "__VITE_ASSET__DNVl_pfV__"